import React from 'react';
import { Link } from 'react-router-dom';

function WorkshopCard({ workshop }) {
  const spotsLeft = workshop.maxParticipants - (workshop.currentParticipants || 0);

  const formatPrice = (price) => {
    if (!price) return '$0';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    }).format(price);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'TBD';
    try {
      return new Date(dateString).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    } catch (error) {
      return 'TBD';
    }
  };

  const getDisplayPrice = () => {
    // Handle different pricing structures
    if (workshop.pricing) {
      // Legacy pricing structure (from mock data) - show the lower price
      return workshop.pricing.doubleOccupancy || workshop.pricing.singleOccupancy || 0;
    }
    
    // New simplified pricing structure
    return workshop.price || 0;
  };

  const getDuration = () => {
    if (!workshop.startDate || !workshop.endDate) return 'TBD';
    try {
      const days = Math.ceil((new Date(workshop.endDate) - new Date(workshop.startDate)) / (1000 * 60 * 60 * 24));
      return `${days} days`;
    } catch (error) {
      return 'TBD';
    }
  };

  return (
    <Link to={`/workshops/${workshop.id}`} className="block group">
      <div className="glass-panel overflow-hidden hover:border-klorah-primary/50 transition-all group-hover:scale-[1.02]">
        {/* Image */}
        <div className="relative h-48 bg-klorah-card">
          <img 
            src={workshop.imageUrl || 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop'} 
            alt={workshop.title}
            className="w-full h-full object-cover"
          />

          {/* Price Badge */}
          <div className="absolute top-4 right-4">
            <div className="px-3 py-1 text-sm font-semibold bg-klorah-primary text-black rounded-lg">
              {formatPrice(getDisplayPrice())}
            </div>
          </div>

          {/* Availability Badge */}
          <div className="absolute bottom-4 left-4">
            <div className={`px-3 py-1 text-sm font-medium rounded-lg ${
              spotsLeft > 0 
                ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30' 
                : 'bg-red-500/20 text-red-400 border border-red-500/30'
            }`}>
              {spotsLeft > 0 ? `${spotsLeft} spots left` : 'Full'}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Title */}
          <h3 className="text-xl font-semibold text-white">
            {workshop.title}
          </h3>

          {/* Location & Dates */}
          <div className="flex items-center text-sm text-klorah-text space-x-2">
            <svg className="w-4 h-4 text-klorah-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span>{workshop.location || 'Location TBD'}</span>
            <span className="text-klorah-text-light">•</span>
            <span>{formatDate(workshop.startDate)} - {formatDate(workshop.endDate)}</span>
          </div>

          {/* Description */}
          <p className="text-klorah-text leading-relaxed">
            {workshop.shortDescription || workshop.description || 'Workshop description coming soon...'}
          </p>

          {/* Details Grid */}
          <div className="grid grid-cols-2 gap-4 py-4 border-t border-klorah-border">
            <div className="space-y-1">
              <div className="text-xs font-medium text-klorah-text-light uppercase tracking-wider">DURATION</div>
              <div className="text-sm font-semibold text-white">
                {getDuration()}
              </div>
            </div>
            <div className="space-y-1">
              <div className="text-xs font-medium text-klorah-text-light uppercase tracking-wider">CAPACITY</div>
              <div className="text-sm font-semibold text-white">Max {workshop.maxParticipants || 'TBD'}</div>
            </div>
          </div>

          {/* Action Button */}
          <div className="pt-2">
            <div className="w-full py-3 text-sm font-semibold text-center bg-klorah-card border border-klorah-border text-klorah-text hover:text-white hover:bg-klorah-border rounded-xl transition-all">
              VIEW DETAILS
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default WorkshopCard; 